// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"83e44af1","239":"0d75d689","732":"b2002fcc"}[chunkId] + ".chunk.js";
};